/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Point} from "./point";

export class HistoryData {
  starting_positions: HistoryEvent[];
  events: HistoryEvent[];
}

export class HistoryEvent {
  entity_type: string;
  instance_id: number;
  location_id: number;
  position: Point;
  timestamp: number;
  movement_type: string;
}

export class HistoryDataGUI {
  locationId: number;
  zoneId: number;
  entityId: number;
  entityType: string;
  point: Point;
  timestamp: number;
}

export class HistoryDataElementUI {
  historyDataLastChanged: number;
  historyData: HistoryDataGUI;
}

export class HistoryDataSecondUI {
  historyDataElement: HistoryDataElementUI[];
}
